import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {Address} from '../restaurant-manager.models';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AddressService {

  constructor(private apiService: ApiService) {}

  update(address: Address): Observable<Address> {
    return this.apiService
      .put<Address>('/addresses/' + address.id, address, true)
      .pipe(map(a => new Address(a)));
  }

  add(address: Address): Observable<Address> {
    return this.apiService
      .post<Address>('/addresses', address, true)
      .pipe(map(a  => new Address(a)));
  }

  remove(address: Address): Observable<boolean> {
    return this.apiService.delete<boolean>('/addresses/' + address.id, true);
  }

  list(): Observable<Address[]> {
    return this.apiService
      .get<Address[]>('/addresses', true)
      .pipe(map(addr => addr.map(a => new Address(a))));
  }

}
